import $ from "jquery";
import Rails from "rails-ujs";
window.jQuery = $;
window.$ = $;
Rails.start();

import "common";
import "components/notice";
import "components/sumsub";
import "components/kyc";
import "components/password_form";

import "investors/index.js";
import "investors/show.js";

import "onboardings/pdfs/index.js";

$(".clickable").on("click", function (e) {
  var link = $(this).find("a").first();

  if (link.length) {
    window.location.href = link.attr("href");
  }
});
